export class ResponseModel {
    isSuccess: boolean;
    message: string;
    data: any;
    dataCount: any;
    exception: object;
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/models/response.model.ts